/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'
// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
// Theme Configurations
import '../themeConfig.js'
// Globally Registered Components
import './globalComponents.js'
import './components/_globals'
// Styles: SCSS
import './assets/scss/main.scss'
// Tailwind
import '@/assets/css/main.css';
// Vue Router
import router from './router'
// Vuex Store
import store from './store/store'
// Vuesax Admin Filters
import './filters/filters'
// Vuejs - Vue wrapper for hammerjs
import {VueHammer} from 'vue2-hammer'
// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
// Custom
import '@/utilities/notificationService'
import ToggleButton from 'vue-js-toggle-button'
import i18n from '@/utilities/i18n'
import {Portal} from "portal-vue";
import {ValidationObserver, ValidationProvider} from 'vee-validate';

import VuePusher from 'vue-pusher';

Vue.use(Vuesax)


Vue.use(VueHammer)


// Feather font icon
require('./assets/css/iconfont.css')

Vue.config.productionTip = false

Vue.use(ToggleButton)

Vue.use(VuePusher, {
  api_key: 'a48b66c5cdc20f8ce2e1',
  options: {
    cluster: 'eu',
    encrypted: true,
  }
});

Vue.component('vue-portal', Portal)
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
